import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tarjetas',
  templateUrl: './tarjetas.component.html',
  styleUrl: './tarjetas.component.css'
})
export class TarjetasComponent {
  @Input() header: string = 'Cumplimiento adulto';
  @Input() value: number = 126;
  @Input() footer: string = 'nov | 22';
  @Input() icon: string = 'trending_up';
  @Input() color: string = '#000';
  /** Color solo del icono; si no se pasa, usa el mismo `color` del valor/texto */
  @Input() iconColor: string = '';
  @Input() siceHeader: string = '3vh';
  @Input() siceValue: string = '5vh';
  @Input() siceFooter: string = '2vh';
  @Input() sice: string = '7vh';
  @Input() iconFirst: boolean = true;
  @Input() showIcon: boolean = true;
  @Input() valueStr: string;

  /** Barra inferior degradada (color → transparente); solo se pinta si viene con valor */
  @Input() barColor: string = '';
  /** % de llenado de la barra (0-100) */
  @Input() barPercent: number = 0;
  @Input() alto: string = '20vh';
}
